// *** Angular
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

// *** Actions
import * as assignmentSubmissionsActions from '../state/action/assignment-submissions.actions';
import * as filtersActions from '../../../../../administrator-components/state/filters/action/filters.actions';
import { environment } from 'src/environments/environment';

// *** Selectors
import { getAssignmentSubmissionsDetails } from '../state/selector/assignment-submissions.selectors';
import { getFiltersStateDetails } from '../../../../../administrator-components/state/filters/selector/filters.selectors';


// *** Services
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelExportService } from 'src/app/services/excel-export.service';
import { PdfExportService } from 'src/app/services/pdf-export.service';
import { AdministratorStatisticsService } from 'src/app/services/administrator-statistics.service';
import { CsvExportService } from 'src/app/services/csv-export.service';
import { DatePipe } from '@angular/common';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { forkJoin, from, Observable } from 'rxjs';
import { concatMap, mergeMap, map, catchError, filter, retryWhen, delay, take, tap, toArray, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AssignmentService } from 'src/app/services/assignment.service';
import { ExternalSessionService } from 'src/app/services/external-session.service';
import { TableColumn } from 'src/app/shared/components/app-table/app-table.component';
@Component({
   selector: 'app-assignment-submissions',
   templateUrl: './assignment-submissions.component.html',
   styleUrls: ['./assignment-submissions.component.scss'],
})
export class AssignmentSubmissionsComponent implements OnInit, OnDestroy {
   /**
    * Variable used to store submission name to filter submissions by name
    */
   submissionName = '';
   /**
    * Varibale used to store student name that used to filter submissions of specific students
    */
   studentName = '';
   /**
    * Variable used to store student index ID for filtering submissions by student index
    */
   studentIndexId = '';
   /**
    * Variable used to store assignment type that has been used to filter assignments
    */
   assignmentType = '-1';
   getFiltersState = true;
   /**
    * Variable used to store information that a thesis is been clicked for expand or not
    */
   expandInfo: any;
   /**
    * Variable used to store submissions
    */
   submissions;
   /**
    * Variable used to store student id that used to expand specific row on HTML
    */
   studentId;
   /**
    * Symbolizing the page of pagination
    */
   page: number = 1;
   /**
    * Timer used for search delay
    */
   timer: any;
   /**
    * Variable used to store number of submissions
    */
   submissionsNumber;
   status = '3';
   getFiltersStateDetails$: any;
   getAssignmentSubmissionsDetails$: any;

   startDate = '';
   endDate = '';
   startTime = '';
   endTime = '';
   showDateRangePicker = false;

   @ViewChild('contentToCapture') contentToCapture: ElementRef;
   reports = [
      { name: this.translate.instant('new_entries.offline_report'), selected: false },
      { name: this.translate.instant('general.submission_files'), selected: false },
   ]
   user;
   private filtersExplicitlyReset = false;
   originalityDisplay: string;
   userInterfaceDisplay: string;
   originalityRiskFactorHighRisk: number;
   originalityRiskFactorMediumRisk: number;
   institutionSettings: any;

   languageMap = {
      'en': 'English',
      'sq': 'Albanian',
      'de': 'German',
      'it': 'Italian',
      'fr': 'French',
      'es': 'Spanish',
      'el': 'Greek',
      'cs': 'Czech',
      'tr': 'Turkish',
      'sk': 'Slovak',
      'lt': 'Lithuanian',
      'lv': 'Latvian',
      'pl': 'Polish',
      'sr': 'Serbian',
      'mk': 'Macedonian',
      'pt': 'Portuguese',
      'nl': 'Dutch',
      'ru': 'Russian',
      'bg': 'Bulgarian',
      'hu': 'Hungarian',
      'ro': 'Romanian',
      'sl': 'Slovenian',
      'sv': 'Swedish',
      'fi': 'Finnish',
      'hr': 'Croatian',
      'bs': 'Bosnian',
      'no': 'Norwegian',
      'da': 'Danish',
      'et': 'Estonian'
   };

   getLanguageNames(code: any, languageMap: { [key: string]: string }): string {
      if (!code) {
         return '';
      }


      let currentValue = code;

      if (code.includes('\\')) {
         console.log('currentValue1', currentValue);
         currentValue = code.replaceAll(/\\/g, '').split('""')[1];
      }

      let safety = 0;
      if (Array.isArray(currentValue) && currentValue.length === 1) {
         currentValue = currentValue[0];
         console.log('currentValue', currentValue);
      }

      while (typeof currentValue === 'string' && safety < 10) {
         try {
            currentValue = JSON.parse(currentValue);
            console.log('currentValue', currentValue);
         } catch (e) {
            break;
         }
         safety++;
      }

      if (Array.isArray(currentValue)) {
         if (currentValue.length === 0) return 'None';

         console.log('currentValue', currentValue);
         return currentValue
            .map(lang => (languageMap[lang.toLowerCase()] || lang))
            .join(', ');
      }

      if (typeof currentValue === 'string') {
         console.log('currentValue', currentValue);
         return languageMap[currentValue.toLowerCase()] || currentValue;
      }

      return '';
   }
   constructor(
      private store: Store,
      private csvExportService: CsvExportService,
      private excelExportService: ExcelExportService,
      private pdfExportService: PdfExportService,
      private spinner: NgxSpinnerService,
      private administratorStatisticsService: AdministratorStatisticsService,
      private datePipe: DatePipe,
      private http: HttpClient,
      private submissionsService: SubmissionsService,
      private userService: UserService,
      private toastrService: ToastrService,
      private translate: TranslateService,
      private assignmentService: AssignmentService,
      private externalSessionService: ExternalSessionService
   ) { }
   ngOnDestroy(): void {
      this.getFiltersStateDetails$.unsubscribe();
      this.getAssignmentSubmissionsDetails$.unsubscribe();

      // Clear filters when navigating away from submissions page
      this.store.dispatch(
         filtersActions.assignmentSubmissionsFilters({
            faculty: null,
            department: null,
            professor: null,
            student: null,
            submission: null,
            indexId: null,
            status: null,
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null
         })
      );
   }

   get columns(): TableColumn[] {
      const baseColumns: TableColumn[] = [
         { key: 'platform', label: ' ', type: 'dot' },
         { key: 'title', label: 'new_entries.title' },
         { key: 'author', label: 'general.author' },
         { key: 'createdAt', label: 'new_entries.submission_date', type: 'date' },
         { key: 'assignments.assignmentType', label: 'new_entries.assignment_type', type: 'template', templateKey: 'assignmentType' }
      ];

      if (this.originalityDisplay !== 'None') {
         baseColumns.push({
            key: 'documentOriginalityPercentage',
            value: 'documentOriginalityPercentage',
            label: 'new_entries.originality_index',
            type: 'badge',
         } as TableColumn);
      }

      baseColumns.push({
         key: 'assignments.assignmentLink',
         label: 'new_entries.originality_report',
         type: 'template',
         templateKey: 'assignmentLink',
      } as TableColumn);

      return baseColumns;
   }

   allSubmissions: any[] = [];
   ngOnInit(): void {
      this.user = JSON.parse(localStorage.getItem('user'));
      const institutionSettings = this.user?.Institution?.InstitutionSettings?.[0];
      this.institutionSettings = institutionSettings;
      this.originalityDisplay = institutionSettings?.originalityDisplay;
      this.userInterfaceDisplay = institutionSettings?.userInterfaceDisplay;
      this.originalityRiskFactorHighRisk = institutionSettings?.originalityRiskFactorHighRisk;
      this.originalityRiskFactorMediumRisk = institutionSettings?.originalityRiskFactorMediumRisk;

      this.getFiltersStateDetails$ = this.store
         .select(getFiltersStateDetails)
         .subscribe((data) => {
            console.log('data getFiltersStateDetails$ 1111', data);

            if (data.assignmentSubmissionsFilters.student != null) {
               this.studentName = data.assignmentSubmissionsFilters.student;
            }
            if (data.assignmentSubmissionsFilters.indexId != null) {
               this.studentIndexId = data.assignmentSubmissionsFilters.indexId;
            }
         });

      this.store.dispatch(
         assignmentSubmissionsActions.loadAssignmentSubmissionsStatistics({
            page: this.page,
            submissionName: this.submissionName,
            studentName: this.studentName,
            assignmentType:
               this.assignmentType == '-1' ? undefined : this.assignmentType,
            indexId: this.studentIndexId,
            status: this.status,
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
         })
      );

      this.getAssignmentSubmissionsDetails$ = this.store
         .select(getAssignmentSubmissionsDetails)
         .subscribe((data) => {
            if (data !== null) {
               // Set hasFlag for each submission, only if assignmentSubmissions is not null
               this.allSubmissions = Array.isArray(data.assignmentSubmissions)
                  ? data.assignmentSubmissions.map(sub => ({
                     ...sub,
                     hasFlag: (sub.characterReplacements > 0 || sub.hiddenText > 0 || sub.imageAsText > 0),
                     documentOriginalityPercentage: sub.assignments?.assignmentType === 'code' ? 'NA' : sub.documentOriginalityPercentage,
                     riskString: sub.assignments?.assignmentType === 'code' ? ' ' : '%',
                     platform: sub?.platform || 'IO',
                     assignments: {
                        ...sub.assignments,
                        isChecked: sub.assignments?.assignmentType === 'code' ? (sub.processed === 1) : true
                     }
                  }))
                  : [];

               // Ensure submissions (used for paginatedData) also has hasFlag
               this.submissions = Array.isArray(data.assignmentSubmissions)
                  ? data.assignmentSubmissions.map(sub => ({
                     ...sub,
                     assignmentType: sub.assignments?.assignmentType,
                     hasFlag: (sub.characterReplacements > 0 || sub.hiddenText > 0 || sub.imageAsText > 0),
                     documentOriginalityPercentage: sub.assignments?.assignmentType === 'code' ? 'NA' : sub.documentOriginalityPercentage,
                     riskString: sub.assignments?.assignmentType === 'code' ? ' ' : '%',
                     platform: sub?.platform || 'IO',
                     assignments: {
                        ...sub.assignments,
                        isChecked: sub.assignments?.assignmentType === 'code' ? (sub.processed === 1) : true
                     }
                  }))
                  : [];

               this.submissionsNumber = data.submissionsNumber;

            }
         });

   }

   /**
    * Function is used to filter by title
    */
   filterWithTimeout() {
      console.log(this.status, "ddc");

      console.log('Filter state:', {
         studentIndexId: this.studentIndexId,
         isActivelyFilteringByIndexId: this.studentIndexId && this.studentIndexId.trim() !== ''
      });
      this.getFiltersState = false;
      this.filtersExplicitlyReset = false; // Reset the flag when user starts filtering

      this.store.dispatch(
         filtersActions.assignmentSubmissionsFilters({
            student: this.studentName !== '-1' ? this.studentName : '',
            submission: this.submissionName,
            indexId: this.studentIndexId,
            status: this.status,
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
            endDate: this.endDate
         })
      );
      let time;
      time = 500;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
         this.changePage(1)
         // this.store.dispatch(
         //    assignmentSubmissionsActions.loadAssignmentSubmissionsStatistics({
         //       page: this.page,
         //       subjectName: this.subject,
         //       assignmentName: this.assignment,
         //       studentName: this.studentName,
         //       submissionName: this.submissionName,
         //    })
         // );
      }, time);
   }
   /**
    * Function is used to filter by assignment type
    * @param type
    */
   filterByType(type) {
      this.assignmentType = type;
      this.store.dispatch(
         assignmentSubmissionsActions.loadAssignmentSubmissionsStatistics({
            page: this.page,
            submissionName: this.submissionName,
            studentName: this.studentName,
            assignmentType:
               this.assignmentType == '-1' ? undefined : this.assignmentType,
            indexId: this.studentIndexId,
            status: this.status,
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
            endDate: this.endDate
         })
      );
   }

   /**
    * Method used to change pagination page. It dispatches an action with page as param.
    * @param event
    */
   changePage(event): void {
      this.page = event;
      this.store.dispatch(
         assignmentSubmissionsActions.loadAssignmentSubmissionsStatistics({
            page: this.page,
            submissionName: this.submissionName,
            studentName: this.studentName,
            assignmentType:
               this.assignmentType == '-1' ? undefined : this.assignmentType,
            indexId: this.studentIndexId,
            status: this.status,
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
            endDate: this.endDate
         })
      );
   }
   /**
    * Function is used to exapnd information
    * @param studentId
    */
   expand(studentId) {
      this.studentId = studentId;
      if (this.expandInfo !== studentId) {
         this.expandInfo = studentId;
      } else {
         this.expandInfo = -1;
      }
   }

   goToLink(id: string): void {
      this.spinner.show();
      const user = JSON.parse(localStorage.getItem('user'));
      // Check if in LTI context
      const isLTI = localStorage.getItem('aId');

      this.externalSessionService.createExternalSession(
         user.id,      // userId
         30,           // expiration: 30 seconds
         false,        // not infinite
         true,         // is for a report
         id,           // submissionId
      ).subscribe(
         (sessionUrl: string) => {
            // Handle LTI differently
            if (isLTI !== null) {
               // For LTI, replace the current window with expanded=false parameter
               window.location.replace(`${sessionUrl}?expanded=false`);
            } else {
               // For regular users, open in a new tab
               window.open(sessionUrl, '_blank');
            }
            this.spinner.hide();
         },
         (error) => {
            console.error('Error creating external session:', error);
            this.toastrService.error(this.translate.instant('errors.session_creation_failed'));
            this.spinner.hide();
         }
      );
   }

   showWarning(message): void {
      this.toastrService.warning(message);
   }

   /**
    * Function is used to reset filters
    */
   resetFilter() {
      this.page = 1;
      this.submissionName = '';
      this.studentName = '';
      this.studentIndexId = '';
      this.filtersExplicitlyReset = true;
      this.status = '3';
      this.startDate = '';
      this.endDate = '';
      this.startTime = '';
      this.endTime = '';

      this.store.dispatch(
         filtersActions.assignmentSubmissionsFilters({
            student: this.studentName,
            submission: this.submissionName,
            indexId: this.studentIndexId,
            startDate: this.startDate || undefined,
            endDate: this.endDate || undefined,
            startTime: this.startTime || undefined,
            endTime: this.endTime || undefined,
            status: this.status || undefined,
         })
      );
      this.store.dispatch(
         assignmentSubmissionsActions.loadAssignmentSubmissionsStatistics({
            page: this.page,
            submissionName: this.submissionName,
            studentName: this.studentName,
            assignmentType:
               this.assignmentType == '-1' ? undefined : this.assignmentType,
            indexId: this.studentIndexId,
            status: this.status,
            startTime: this.startTime,
            endTime: this.endTime,
            startDate: this.startDate,
            endDate: this.endDate
         })
      );
   }

   prepareExportData(data: any[]) {
      let rows = [
         ["Submissions"],
         [""],
         [
            "Submission title",
            "Full name",
            "Submission Date",
            "Document language similarity",
            "Originality Index"
         ],
      ]

      data.forEach(submission => {
         const isCodeSubmission = submission.assignments?.assignmentType === 'code';

         let originalLanguage = isCodeSubmission ? 'N/A' :
            (submission.originalLanguage !== null ? this.getLanguageNames(submission.originalLanguage, this.languageMap) : '--');

         let originalPercentage = isCodeSubmission ? '' :
            (submission.originalLanguage !== null ? submission.originalPercentage.toFixed(2) + '%' : '---');

         let originalityIndex = isCodeSubmission ? 'N/A' :
            (submission.documentOriginalityPercentage !== null ? submission.documentOriginalityPercentage.toFixed(2) + '%' : 'N/A');

         rows.push([
            `"${submission.title}"`,
            submission.author,
            this.datePipe.transform(submission.createdAt, 'dd/MM/yyyy hh:mm'),
            originalLanguage === '--' ? originalLanguage : `"${originalLanguage} ${originalPercentage}"`.trim(),
            originalityIndex
         ]);
      });

      return rows
   }

   exportToCSV() {
      this.spinner.show();
      this.fetchAllSubmissionsInBatches()
         .pipe(
            catchError((error) => {
               console.error('Error exporting CSV', error);
               this.spinner.hide();
               return of([]);
            })
         )
         .subscribe((submissions) => {
            if (!submissions || submissions.length === 0) {
               this.spinner.hide();
               this.toastrService.warning(this.translate.instant('new_entries.no_submissions_found'));
               return;
            }
            const rows = this.prepareExportData(submissions);
            this.csvExportService.exportToCSV(rows, 'Submissions - Student Submissions Report');
            this.spinner.hide();
         });
   }

   exportToExcel() {
      this.spinner.show();
      this.fetchAllSubmissionsInBatches()
         .pipe(
            catchError((error) => {
               console.error('Error exporting Excel', error);
               this.spinner.hide();
               return of([]);
            })
         )
         .subscribe((submissions) => {
            if (!submissions || submissions.length === 0) {
               this.spinner.hide();
               this.toastrService.warning(this.translate.instant('new_entries.no_submissions_found'));
               return;
            }
            const rows = this.prepareExportData(submissions);
            this.excelExportService.exportToExcel(rows, 'Submissions - Student Submissions Report');
            this.spinner.hide();
         });
   }

   exportToPDF() {
      this.spinner.show()
      if (this.contentToCapture) {
         this.pdfExportService.captureAndExportPDF(this.contentToCapture.nativeElement, 'Submissions - Student Submissions Report.pdf');
         this.spinner.hide()
      } else {
         console.error('Content to capture is not available yet.');
         this.spinner.hide()
      }
   }

   toggleSelection(report: any) {
      report.selected = !report.selected;
   }

   anyReportsSelected(): boolean {
      return this.reports.some(report => report.selected);
   }

   retryWithDelay = (delayMs: number, maxRetry: number) => retryWhen(errors =>
      errors.pipe(
         delay(delayMs),
         take(maxRetry)
      )
   );

   selectedSubmissions: any[] = [];
   anySelected = false;

   onTableSelectionChange(selectedRows: any[]): void {
      this.selectedSubmissions = selectedRows;
      this.anySelected = selectedRows.length > 0;
   }


   downloadReport(submissionId: string, reportType: string) {
      return this.http.get(
         `${environment.apiUrl}/submission/${submissionId}/offlineReport?reportType=${reportType}&bulk=true`,
         { responseType: 'json' }
      ).pipe(
         timeout(60000), // Cancel the request if it takes longer than 1 minute
         this.retryWithDelay(1000, 3),
         catchError((error) => {
            console.error(`Failed to download report for submission ${submissionId}`, error);
            return of(null);
         })
      );
   }

   downloadAiReport(submissionId: string) {
      return this.http.get(
         `${environment.apiUrl}/submission/${submissionId}/aiOfflineReport?reportType='test'`,
         { responseType: 'json' }
      ).pipe(
         timeout(60000), // Cancel the request if it takes longer than 1 minute
         this.retryWithDelay(1000, 3),
         catchError((error) => {
            console.error(`Error fetching AI report for submission ${submissionId}`, error);
            return of(null);
         })
      );
   }

   allSelected: boolean = false;

   onSelectionChanged(selectedRows: any[]): void {
      this.selectedSubmissions = selectedRows;
   }

   onSelectAllChanged(allChecked: boolean): void {
      this.allSelected = allChecked;
   }

   downloadOriginalDocument(submissionId: string) {
      return this.http.get(`${environment.apiUrl}/document/${submissionId}`, { responseType: 'json' }).pipe(
         timeout(60000), // Cancel the request if it takes longer than 1 minute
         this.retryWithDelay(1000, 3),
         catchError((error) => {
            console.error(`Error fetching original document for submission ${submissionId}`, error);
            return of(null);
         })
      );
   }

   downloadAll() {
      const useAll = this.allSelected;
      this.spinner.show();
      this.userService.spinnerSubject.next(true);
      this.userService.messageSubject.next('Hang on this may take a while.');
      this.administratorStatisticsService.assignmentsSubmissionsStatistics(
         '-1',
         this.assignmentType == '-1' ? undefined : this.assignmentType,
         this.submissionName,
         this.studentName,
         this.studentIndexId,
         this.status || undefined,
         this.startDate || undefined,
         this.endDate || undefined,
         this.startTime || undefined,
         this.endTime || undefined,
      )
         .pipe(
            catchError((error) => {
               console.error('Error fetching submission details for offline export', error);
               this.userService.spinnerSubject.next(false);
               this.userService.messageSubject.next('');
               this.spinner.hide();
               return of(null);
            }),
            mergeMap((response) => {
               if (!response || !response.data.submissions) {
                  return of(null);
               }

               this.allSubmissions = response.data.submissions;

               const submissions = useAll
                  ? this.allSubmissions
                  : this.selectedSubmissions;

               const zip = new JSZip();
               let fileCount = 0;
               let processedCount = 0;
               let failedCount = 0;
               const failedSubmissions = [];
               const startTime = new Date().getTime(); // Record the start time

               // Create the report types array based on selected reports
               const reportTypes = [];
               if (this.reports.find((report) => report.name === 'Offline Report' && report.selected)) {
                  reportTypes.push({ type: 'crossplag', label: 'Original' });
               }

               if (this.reports.find((report) => report.name === 'Submission files' && report.selected)) {
                  reportTypes.push({ type: 'document', label: 'Document' });
               }

               // Calculate total reports dynamically
               let totalReports = 0;
               submissions.forEach((submission) => {
                  if (
                     submission.processed !== 1
                  ) {
                     return false;
                  }
                  totalReports++;
                  return true;
               });
               // Batch processing
               const batchSize = 5; // Adjust batch size as needed
               const submissionBatches = [];
               for (let i = 0; i < submissions.length; i += batchSize) {
                  submissionBatches.push(submissions.slice(i, i + batchSize));
               }

               return from(submissionBatches).pipe(
                  concatMap(batch =>
                     forkJoin(batch.map((submission: any) =>
                        from(reportTypes).pipe(
                           filter(() => {
                              return submission.processed === 1;
                           }),
                           concatMap((reportType: any) => {
                              let downloadObservable;
                              this.userService.messageSubject.next(this.translate.instant('new_entries.hang_on_this_may_take_a_while', { count: totalReports }));
                              if (reportType.type === 'document') {
                                 downloadObservable = this.submissionsService.downloadOriginalDocument(submission.id).pipe(
                                    concatMap((data: any) => {
                                       if (data && data.urlToDownload) {
                                          return this.http.get(data.urlToDownload, { responseType: 'arraybuffer' }).pipe(
                                             map((fileData: ArrayBuffer) => ({
                                                blob: new Blob([fileData], { type: 'application/pdf' }),
                                                filename: `${submission.title}-${reportType.label}.pdf`
                                             }))
                                          );
                                       }
                                       return of(null);
                                    })
                                 );
                              } else {
                                 // This is for the 'crossplag' type (Offline Report)
                                 downloadObservable = this.downloadReport(submission.id, reportType.type).pipe(
                                    concatMap((data: any) => {
                                       if (data) {
                                          return this.http.get(data.presignedS3UrlDownload, { responseType: 'arraybuffer' }).pipe(
                                             map((fileData: ArrayBuffer) => ({
                                                blob: new Blob([fileData], { type: 'application/pdf' }),
                                                filename: `${submission.title}-${reportType.label}.pdf`
                                             }))
                                          );
                                       }
                                       return of(null);
                                    })
                                 );
                              }

                              return downloadObservable.pipe(
                                 catchError((error) => {
                                    failedCount++;
                                    failedSubmissions.push(submission.id);
                                    return of(null);
                                 })
                              );
                           }),
                           toArray() // Collect all observables for this submission
                        )
                     ))
                  ),
                  tap({
                     next: (results: any) => {
                        results.flat().forEach(result => {
                           processedCount++;
                           if (result && result.blob) {
                              const uniqueFilename = this.getUniqueFilename(zip, result.filename);
                              zip.file(uniqueFilename, result.blob);
                              fileCount++;
                           }
                        });
                        this.updateProgress(processedCount, totalReports);
                     },
                     error: (error) => {
                        console.error('An error occurred during report export', error);
                        this.userService.spinnerSubject.next(false)
                        this.userService.messageSubject.next('')
                        this.spinner.hide();
                     },
                     complete: async () => {
                        const endTime = new Date().getTime(); // Record the end time
                        const duration = (endTime - startTime) / 1000; // Calculate the duration in seconds
                        console.log(`Total duration: ${duration} seconds`);

                        if (failedCount > 0) {
                           const failedIds = 'The documents with the following IDs could not be downloaded:\n\n' + failedSubmissions.join('\n') + '\n\nFor more information on this matter, please contact us at support.originality@inspera.com.';
                           zip.file('failed_submissions.txt', failedIds);
                        }
                        if (fileCount > 0) {
                           console.log('Generating ZIP file...');
                           const content = await zip.generateAsync({ type: 'blob' });
                           saveAs(content, 'reports.zip');
                           console.log('All reports have been bundled into a ZIP file');
                           this.toastrService.success(this.translate.instant('new_entries.your_reports_generated_successfully'));
                        } else {
                           console.error('No reports were downloaded');
                           this.toastrService.warning(this.translate.instant('new_entries.no_reports_match_filter'));
                        }

                        console.log(`Failed to download ${failedCount} reports for submissions: ${failedSubmissions.join(', ')}`);
                        this.userService.spinnerSubject.next(false)
                        this.userService.messageSubject.next('')
                        this.spinner.hide();
                     }
                  })
               );
            })
         )
         .subscribe();
   }

   updateProgress(processedCount: number, totalReports: number) {
      console.log(`Processed ${processedCount} out of ${totalReports} reports`);
   }

   fetchAllSubmissionsInBatches(): Observable<any[]> {
      const exportPageSize = 100;
      return new Observable((observer) => {
         this.administratorStatisticsService.assignmentsSubmissionsStatistics(
            '1',
            this.assignmentType == '-1' ? undefined : this.assignmentType,
            this.submissionName,
            this.studentName,
            this.studentIndexId,
            this.status || undefined,
            this.startDate || undefined,
            this.endDate || undefined,
            this.startTime || undefined,
            this.endTime || undefined,
            exportPageSize,
         ).subscribe(
            (firstResponse) => {
               if (!firstResponse || !firstResponse.data || !firstResponse.data.submissions) {
                  observer.next([]);
                  observer.complete();
                  return;
               }

               const totalSubmissions = firstResponse.data.submissionsNumber;
               const totalPages = Math.ceil(totalSubmissions / exportPageSize);

               console.log(`Total submissions: ${totalSubmissions}, Total pages: ${totalPages}`);

               const parallelBatchSize = 20;
               let allSubmissions: any[] = firstResponse.data.submissions;

               const fetchBatchOfPages = (startPage: number, endPage: number) => {
                  const pageRequests = [];
                  for (let page = startPage; page <= endPage; page++) {
                     pageRequests.push(
                        this.administratorStatisticsService.assignmentsSubmissionsStatistics(
                           page.toString(),
                           this.assignmentType == '-1' ? undefined : this.assignmentType,
                           this.submissionName,
                           this.studentName,
                           this.studentIndexId,
                           this.status || undefined,
                           this.startDate || undefined,
                           this.endDate || undefined,
                           this.startTime || undefined,
                           this.endTime || undefined,
                           exportPageSize,
                        )
                     );
                  }
                  return forkJoin(pageRequests);
               };

               const processBatches = (currentStartPage: number) => {
                  if (currentStartPage > totalPages) {
                     console.log(`Finished fetching all ${allSubmissions.length} submissions`);
                     observer.next(allSubmissions);
                     observer.complete();
                     return;
                  }

                  const endPage = Math.min(currentStartPage + parallelBatchSize - 1, totalPages);
                  console.log(`Fetching pages ${currentStartPage} to ${endPage} in parallel`);

                  fetchBatchOfPages(currentStartPage, endPage).subscribe(
                     (responses: any[]) => {
                        responses.forEach((response) => {
                           if (response && response.data && response.data.submissions) {
                              allSubmissions = allSubmissions.concat(response.data.submissions);
                           }
                        });
                        console.log(`Fetched ${allSubmissions.length}/${totalSubmissions} submissions`);
                        processBatches(endPage + 1);
                     },
                     (error) => {
                        console.error('Error fetching batch:', error);
                        observer.next(allSubmissions);
                        observer.complete();
                     }
                  );
               };

               if (totalPages > 1) {
                  processBatches(2);
               } else {
                  observer.next(allSubmissions);
                  observer.complete();
               }
            },
            (error) => {
               console.error('Error fetching first page:', error);
               observer.error(error);
            }
         );
      });
   }

   getUniqueFilename(zip: JSZip, filename: string): string {
      // Sanitize the filename by replacing slashes and other problematic characters
      let sanitizedFilename = filename.replace(/[\/\\:*?"<>|]/g, '_');
      let uniqueFilename = sanitizedFilename;
      let counter = 1;
      while (zip.files[uniqueFilename]) {
         uniqueFilename = sanitizedFilename.replace(/(\.\w+)?$/, `(${counter++})$1`);
      }
      return uniqueFilename;
   }

   openCodeReport(submission: any) {
      const assignmentId = submission.assignments.id
      const userName = submission.author
      const fileName = submission.title
      const language = localStorage.getItem('websiteLanguage')

      this.spinner.show();

      this.assignmentService.getCodePresignedUrl(assignmentId, userName, fileName).subscribe((data) => {
         if (data && data.presignedUrl) {
            const reportUrl = environment.externalCodeReport + '?lang=' + language + '&url=' + data.presignedUrl
            window.open(reportUrl, '_blank');
         }
         this.spinner.hide();
      })
   }

   // Date Range Filter Methods
   getDateRangePlaceholder(): string {
      return 'mm/dd/yyyy';
   }

   getDateRangeDisplayText(): string {
      if (!this.startDate && !this.endDate) {
         return '';
      }

      const formatDate = (date: string, time: string): string => {
         if (!date) return '';
         const dateObj = new Date(date);

         // Use shorter date format to save space
         const formattedDate = dateObj.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
         });

         if (time) {
            const timeObj = new Date(`2000-01-01T${time}`);
            const formattedTime = timeObj.toLocaleTimeString('en-US', {
               hour: 'numeric',
               minute: '2-digit',
               hour12: true
            });
            return `${formattedDate}, ${formattedTime}`;
         }

         return formattedDate;
      };

      const startText = formatDate(this.startDate, this.startTime);
      const endText = formatDate(this.endDate, this.endTime);

      if (startText && endText) {
         // Check if both dates are the same day
         if (this.startDate === this.endDate) {
            const dateStr = new Date(this.startDate).toLocaleDateString('en-US', {
               month: 'short',
               day: 'numeric',
               year: 'numeric'
            });

            if (this.startTime && this.endTime) {
               const startTimeStr = new Date(`2000-01-01T${this.startTime}`).toLocaleTimeString('en-US', {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
               });
               const endTimeStr = new Date(`2000-01-01T${this.endTime}`).toLocaleTimeString('en-US', {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
               });
               return `${dateStr}, ${startTimeStr} - ${endTimeStr}`;
            } else if (this.startTime) {
               return `${dateStr}, from ${formatDate(this.startDate, this.startTime).split(', ')[1]}`;
            } else if (this.endTime) {
               return `${dateStr}, until ${formatDate(this.endDate, this.endTime).split(', ')[1]}`;
            } else {
               return `${dateStr} (All Day)`;
            }
         } else {
            // Different dates - use compact format
            return `${startText} → ${endText}`;
         }
      } else if (startText) {
         return `From: ${startText}`;
      } else if (endText) {
         return `Until: ${endText}`;
      }

      return '';
   }

   toggleDateRangePicker(): void {
      this.showDateRangePicker = !this.showDateRangePicker;

      // Add click listener to close when clicking outside
      if (this.showDateRangePicker) {
         setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick.bind(this));
         }, 0);
      } else {
         document.removeEventListener('click', this.handleOutsideClick.bind(this));
      }
   }

   handleOutsideClick(event: Event): void {
      const target = event.target as HTMLElement;
      const dateRangePicker = document.querySelector('.date-range-filter');

      if (dateRangePicker && !dateRangePicker.contains(target)) {
         this.closeDateRangePicker();
      }
   }

   closeDateRangePicker(): void {
      this.showDateRangePicker = false;
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
   }

   onDateRangeChange(): void {
      // Auto-update the display text as user selects dates/times
      // This provides real-time feedback
   }

   clearDateRange(): void {
      this.startDate = '';
      this.endDate = '';
      this.startTime = '';
      this.endTime = '';
      // Auto-apply the clear action
      this.applyDateRange();
   }

   applyDateRange(): void {
      this.closeDateRangePicker();
      // Small delay to allow modal close animation
      setTimeout(() => {
         this.filterWithTimeout();
      }, 100);
   }

   dateTimeFilter(): void {
      let time = 500;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
         this.store.dispatch(
            filtersActions.assignmentSubmissionsFilters({
               student: this.studentName !== '-1' ? this.studentName : '',
               submission: this.submissionName,
               indexId: this.studentIndexId,
               startDate: this.startDate || undefined,
               endDate: this.endDate || undefined,
               startTime: this.startTime || undefined,
               endTime: this.endTime || undefined,
               status: this.status || undefined,
            })
         );
      }, time);
   }

}
